import React from 'react';
import MDCTextField from './MDCTextField.js.jsx';
import MDCSelect from './MDCSelect.js.jsx';
import MDCCheckbox from './MDCCheckbox.js.jsx';
import classNames from 'classnames';
import tenantFormStyles from '../../../stylesheets/management_site/tenantForm.module.scss';
import newLeaseModalStyles from '../../../stylesheets/management_site/newLeaseModal.module.scss';

const TenantFormAddressFields = ({
  tenantIndex,
  selectedCountry,
  selectedState,
  onCountryChange,
  onStateChange,
  stateLabel,
  zipLabel,
  addressCountryList = [],
  addressStateList = {},
  usePropertyAddress,
  onUsePropertyAddressChange,
}) => {
  const getStatesForCountry = (country) => {
    if (!country || !addressStateList) {
      return [];
    }

    const countryStates = addressStateList[country];

    if (!countryStates) {
      return [];
    }

    const stateOptions = Object.values(countryStates).map((stateName) => ({
      value: stateName,
      label: stateName,
    }));

    if (stateOptions.length === 0) stateOptions.push({ value: '', label: '' });

    return [...stateOptions];
  };

  const stateOptions = getStatesForCountry(selectedCountry);
  return (
    <div className={newLeaseModalStyles.newLeaseModalSection}>
      <div className={newLeaseModalStyles.sectionHeader}>
        <h3 className={newLeaseModalStyles.sectionTitle}>
          Address Information
        </h3>
      </div>
      <div className={newLeaseModalStyles.sectionContent}>
        <input
          type="hidden"
          name={`lease[tenant_lease_relationships_attributes][${tenantIndex}][tenant_attributes][address_attributes][id]`}
        />
        <div className="pm-flex pm-flex-2">
          <MDCTextField
            label="Address Line 1"
            name={`lease[tenant_lease_relationships_attributes][${tenantIndex}][tenant_attributes][address_attributes][addressline1]`}
            id={`lease_tenant_lease_relationships_attributes_${tenantIndex}_tenant_attributes_address_attributes_addressline1`}
            className="new-first-name"
          />
          <MDCTextField
            label="Address Line 2"
            name={`lease[tenant_lease_relationships_attributes][${tenantIndex}][tenant_attributes][address_attributes][addressline2]`}
            id={`lease_tenant_lease_relationships_attributes_${tenantIndex}_tenant_attributes_address_attributes_addressline2`}
          />
        </div>

        <div className="pm-flex pm-flex-4">
          <MDCTextField
            label="City"
            name={`lease[tenant_lease_relationships_attributes][${tenantIndex}][tenant_attributes][address_attributes][city]`}
            id={`lease_tenant_lease_relationships_attributes_${tenantIndex}_tenant_attributes_address_attributes_city`}
          />

          <MDCSelect
            label={stateLabel}
            name={`lease[tenant_lease_relationships_attributes][${tenantIndex}][tenant_attributes][address_attributes][state]`}
            id={`lease_tenant_lease_relationships_attributes_${tenantIndex}_tenant_attributes_address_attributes_state`}
            options={stateOptions}
            defaultValue={selectedState}
            onChange={onStateChange}
          />

          <MDCTextField
            label={zipLabel}
            name={`lease[tenant_lease_relationships_attributes][${tenantIndex}][tenant_attributes][address_attributes][zipcode]`}
            id={`lease_tenant_lease_relationships_attributes_${tenantIndex}_tenant_attributes_address_attributes_zipcode`}
          />

          <MDCSelect
            label="Country"
            name={`lease[tenant_lease_relationships_attributes][${tenantIndex}][tenant_attributes][address_attributes][country]`}
            id={`lease_tenant_lease_relationships_attributes_${tenantIndex}_tenant_attributes_address_attributes_country`}
            options={[
              { value: '', label: '' },
              ...(addressCountryList?.map((c) => ({ value: c, label: c })) ||
                []),
            ]}
            defaultValue={selectedCountry}
            onChange={onCountryChange}
          />
        </div>

        <div className={tenantFormStyles.addressCheckboxContainer}>
          <MDCCheckbox
            label="Use Property Address"
            id={`building_address-[${tenantIndex}]`}
            className={classNames(
              'use_building_address',
              `use_building_address_${tenantIndex}`
            )}
            checked={usePropertyAddress}
            onChange={onUsePropertyAddressChange}
          />
        </div>
      </div>
    </div>
  );
};

export default TenantFormAddressFields;
